import { createContext, useContext } from 'react'
import { OVERVIEW_ROUTE } from '@ucc/unified-admin-common'

import config from '../../config'
import useUserHasOnlyBillingAdminRoles from '../../hooks/useUserHasOnlyBillingAdminRoles'
import { useAccountContext } from '../contexts/AccountContext'
import { UnleashContext } from './UnleashProvider'

export interface DefaultPage {
  defaultPage: string
}
export const DefaultPageContext = createContext<DefaultPage>({ defaultPage: config.DEFAULT_APP })

export const DefaultPageProvider = ({ children }) => {
  const { accountKey } = useAccountContext()
  const isUserHasOnlyGtcBillingAdminRoles = useUserHasOnlyBillingAdminRoles()
  const { gotoLaunchpadEnabled } = useContext(UnleashContext)
  const defaultPage = isUserHasOnlyGtcBillingAdminRoles(accountKey)
    ? config.DEFAULT_GTC_BILLING_APP
    : gotoLaunchpadEnabled
    ? OVERVIEW_ROUTE
    : config.DEFAULT_APP

  return <DefaultPageContext.Provider value={{ defaultPage }}>{children}</DefaultPageContext.Provider>
}
